/**
 * A dismissal that lasts a while: `stampDismissal` writes the time under
 * `key` in localStorage, and `isDismissedWithin` answers whether that stamp
 * is younger than `ttlMs`, so a hidden banner or prompt comes back later.
 * Both swallow storage errors (private mode): the read answers false and the
 * write just doesn't persist.
 */
export function isDismissedWithin(key: string, ttlMs: number): boolean {
  try {
    const raw = localStorage.getItem(key);
    return raw ? Date.now() - Number(raw) < ttlMs : false;
  } catch {
    return false;
  }
}

export function stampDismissal(key: string): void {
  try {
    localStorage.setItem(key, String(Date.now()));
  } catch {
    // Storage unavailable (private mode): the dismissal just won't persist.
  }
}
